//import './VideoGallery.css';

interface IProps {
  size: string[],
  items: number | null,
  s: number[],
  t: number[],
  isEditMode?: boolean,
  onClick: () => void,
  onMouseEnter: () => void
  onMouseLeave: () => void
}

export default class VideoGalleryService {

  public static itemsSize = [0,0];
  public getPlay({ size = ["30%", "30%"], s = [1, 1], t = [0, 0], onClick = () => { }, }: Partial<IProps> = {}): JSX.Element {
  
    let transform = "scale(0.25,0.25) translate(48,48)"
    let transformButton = "scale(0.75,0.75) translate(13,10)"

    return (
      <>
        <svg
          id="video_play_button"
          onClick={(e) => { onClick() }}
          width={size[0]}
          height={size[1]}
          viewBox="0 0 32 32">
          <g transform={transform}>
            <circle cx={"50%"} cy={"50%"} r={"50%"} fill="#ffffff" />
            <g transform={transformButton} >
              <path fill="#000000" d="M19.173 10.407a1.406 1.406 0 0 1 0 2.436L2.298 22.586a1.406 1.406 0 0 1-2.11-1.218V1.882A1.406 1.406 0 0 1 2.298.664z" />
            </g>
          </g>
        </svg>

      </>
    )
  }
}